<template lang='pug' src='./footer.pug'></template>

<script>
import Loader from 'components/loader/loader'

export default {
  name: 'about-us',
  data () {
    return {
      isCaptchaValid: true, // Initial state
      a: Math.floor(Math.random() * 10),
      b: Math.floor(Math.random() * 10)
    }
  },
  computed: {
    props () {
      return this.$store.state.app['footer']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Loader
  },
  methods: {
    // validateCaptcha (event) {
    //   if (!this.isCaptchaValid) {
    //     event.preventDefault()
    //     alert('Incorrect math answer. Please try again.')
    //   }
    //   this.$refs.miniSurveyView3337.submit()
    // }
    handleSubmit () {
      // event.preventDefault()
      let name = this.$refs.fname.value
      let phone = this.$refs.phone.value
      let email = this.$refs.email.value
      let date = this.$refs.date.value
      if (name === '') {
        alert('Please enter full name.')
        return false
      }
      if (phone === '') {
        alert('Please enter a phone number')
        return false
      }
      if (email === '') {
        alert('Please enter an email address.')
        return false
      }
      if (date === '') {
        alert('Please enter date')
        return false
      }
      let captchaInput = parseInt((this.$refs.captchaInput).value)
      let sum = this.a + this.b
      if (sum === captchaInput) {
        (this.$refs.surveyform).submit()
      } else {
        this.isCaptchaValid = false
        return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// footer.vue?666b1dfd